import axios from 'axios'
import config from '@/config'

const actions = {
  GET_QUESTION_FILES({rootGetters}, filesId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'question-file/files/' + filesId, {
          headers: rootGetters.getRequestConfig.headers,
          responseType: 'blob'
        })
        .then(response => resolve(response))
        .catch(err => reject(err))
    })
  },
  DELETE_QUESTION_FILE({rootGetters}, fileId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(config.APi_URL + 'question-file/delete/' + fileId, rootGetters.getRequestConfig)
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  GET_QUESTIONS({rootGetters}, meetingId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + `question/${meetingId}/all`, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  SAVE_QUESTION({rootGetters}, question) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.APi_URL + 'question/save', question, rootGetters.getRequestMultipartConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  UPDATE_QUESTION({rootGetters}, question) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.APi_URL + 'question/update', question, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  DELETE_QUESTION({rootGetters}, questionId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(config.APi_URL + `question/delete/${questionId}`, rootGetters.getRequestConfig)
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  SAVE_QUESTION_ANSWERS({rootGetters}, answer) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.APi_URL + 'question-answer/save/all', answer, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  SAVE_QUESTION_FILE({rootGetters}, file) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.APi_URL + 'question-file/save', file, rootGetters.getRequestMultipartConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default {
  namespaced: true,
  actions
}
